<div class="container my-3">
    <div class="d-flex align-items-center mt-3">
        <h1 class="sub-header-title">{{ !this.data.existingGuest ? 'Add ' : 'Edit '}} Guest</h1>
    </div>
    <div class="row my-3">
        <form [formGroup]="this.data.form">
            <div class="row mt-3">
                <div class="d-flex flex-column mb-3">
                    <h2 class="sub-form-header-title">Basic Info</h2>
                </div>
            </div>
            <div class="row guest-form">
                <div class="col d-flex flex-column">
                    <mat-form-field class="form-input" appearance="outline" hideRequiredMarker>
                        <mat-label>First Name<span class="red">*</span></mat-label>
                        <input type="text" matInput formControlName="first_name" placeholder="First Name">
                        <mat-error *ngIf="!this.data.form.get('first_name')?.value">Required</mat-error>
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field class="form-input" appearance="outline">
                        <mat-label>Middle Name</mat-label>
                        <input type="text" matInput formControlName="middle_name" placeholder="Middle Name">
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field class="form-input" appearance="outline" hideRequiredMarker>
                        <mat-label>Last Name<span class="red">*</span></mat-label>
                        <input type="text" matInput formControlName="last_name" placeholder="Last Name">
                        <mat-error *ngIf="!this.data.form.get('last_name')?.value">Required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row mb-3 mt-2 guest-form">
                <div class="col d-flex flex-column">
                    <mat-form-field class="form-input" appearance="outline">
                        <mat-label>Email</mat-label>
                        <input type="text" matInput formControlName="email" placeholder="Email">
                        <mat-hint class="email-hint">
                        * Some screening requests require contact information.
                        </mat-hint>
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field class="form-input" appearance="outline">
                        <mat-label>Phone Number</mat-label>
                        <input type="text" matInput placeholder="555-123-4567" formControlName="phone_number" (input)="onPhoneNumberChanged($event)">
                        <mat-hint>Ex: (XXX) XXX-XXXX</mat-hint>
                        <mat-error *ngIf="data.form.controls['phone_number'].invalid">
                            Required | (XXX) XXX-XXXX
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field class="form-input" appearance="outline">
                        <mat-label>Date of Birth</mat-label>
                        <input matInput formControlName="birth_date" [matDatepicker]="picker" [max]="maxDate" [min]="minDate">
                        <mat-hint class="birth-date-hint">
                            Warning! Guests under 18 years of age cannot have a verification performed.
                        </mat-hint>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker startView="multi-year"></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row mt-4">
                <div class="d-flex flex-column mb-3">
                    <h2 class="sub-form-header-title">Address</h2>
                </div>
            </div>
            <form formGroupName="address">
                <div class="row guest-form">
                    <div class="col d-flex flex-column">
                        <mat-form-field class="form-input" appearance="outline">
                            <mat-label>Address Line 1</mat-label>
                            <input type="text" matInput formControlName="address_line_1" placeholder="Address Line 1">
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column">
                        <mat-form-field class="form-input" appearance="outline">
                            <mat-label>Address Line 2</mat-label>
                            <input type="text" matInput formControlName="address_line_2" placeholder="Address Line 2">
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column">
                        <mat-form-field class="form-input" appearance="outline">
                            <mat-label>City</mat-label>
                            <input type="text" matInput formControlName="city" placeholder="City">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row guest-form">
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline">
                            <mat-label>State</mat-label>
                            <mat-select formControlName="state">
                                <mat-option *ngFor="let state of this.states" [value]="state.value">
                                    {{ state.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column">
                        <mat-form-field class="form-input" appearance="outline">
                            <mat-label>Postal Code</mat-label>
                            <input type="text" matInput formControlName="postal_code" placeholder="Postal Code">
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-column">
                        <mat-form-field appearance="outline">
                            <mat-label>Country</mat-label>
                            <mat-select formControlName="country_id">
                                <mat-option *ngFor="let country of this.data.countries" [value]="country.id">
                                    {{ country.display_text }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </form>
    </div>
    <div class="my-2 d-flex justify-content-end">
        <button mat-raised-button class="finish-button" (click)="cancelAddGuest()">
            <mat-icon>cancel</mat-icon>
            Cancel
        </button>
        <button mat-raised-button class="action-button submit-guest-button"
            [disabled]="!canCreateGuest()" (click)="submitGuest()">
            <mat-icon>check</mat-icon>
            @if(!this.data.existingGuest) {
                Add Guest
            }
            @if(this.data.existingGuest) {
                Update Guest
            }
        </button>
    </div>
    @if(!canCreateGuest()) {
        <div class="my-3">
            <mat-action-row class="mt-4 d-flex justify-content-end">
                <div class="d-flex justify-content-end align-items-center text-muted">
                    <span class="required-input">*</span>&nbsp;- Required fields before submitting Guest.
                </div>
            </mat-action-row>
        </div>
    }
</div>